/**
 * Exact chantier locations live only under the demand document:
 *   demands/{demandId}/locations/private
 *
 * The former top-level demand_locations collection is intentionally no longer
 * read or written by the application. Run the supplied two-root migration once
 * before deploying these files if legacy records still exist.
 */
export const privateDemandLocationRef = (db, demandId) => (
  db.collection('demands').doc(demandId).collection('locations').doc('private')
);

export const readPrivateDemandLocation = async (db, demandId) => {
  if (!demandId) return { data: null, source: null, snapshot: null };
  const snapshot = await privateDemandLocationRef(db, demandId).get();
  return snapshot.exists
    ? { data: snapshot.data(), source: 'nested', snapshot }
    : { data: null, source: null, snapshot };
};
